import i18next from 'i18next';

i18next.addResources('en', 'AdelphiStatementsMashingAndFermentation', {
  viewTotals: 'View Totals',
  mashingId: 'Mashing ID',
  mashDate: 'Date',
  tones: 'Tonnes',
  washbackNumber: 'W/B',
  yeastDistilamax: 'Yeast Distilamax MW',
  yeastFermentis: 'Yeast Fermentis',
  yeastSafspiritM1: 'Yeast Safspirit M-1',
  yeastSafspiritD53: 'Yeast Safspirit D-53',
  fillId: 'Fill ID',
  peated: 'Peated',
  yeast: 'Yeast',
  washbackTemp: 'W/B Temp',
  wortVolume: 'Wort Volume',
  originalGravity: 'OG',
  finalGravity: 'FG',
  da: 'DA',
  mte: 'MTE',
  psy: 'PSY',
  alcoholAtt: 'Alcohol Att',
  navBarTitle: 'Period: {{periodId}}\n{{peated}}'
});
